import { type Framework } from '@toeverything/infra';

import { PerformanceMonitorService } from './services/performance-monitor';

export { PerformanceMonitorService };
export * from './hooks/use-performance';
export * from './services/api-interceptor';
export * from './setup';
export * from './types';
export * from './utils/worker-monitor';

export function configurePerformanceModule(framework: Framework) {
  framework.service(PerformanceMonitorService);
}
